/**
*   Created by FANGlh on 2018/11/14 17:36.
*   Desc:
*/

import React,{Component} from 'react';
import './PhoneApply.css';
import delete_img from '../../style/imgs/delete.png';
import {Icon} from 'antd';
import {Toast} from 'antd-mobile';


export default class PhoneItem extends Component{
    constructor(props){
        super(props);

    }
    render(){

        return(
            <div onChange={this.handelValueCom}>
                <div style={{display:'flex',flexDirection:'row',backgroundColor:'#F2F2F2'}}>
                    <div className="res_detail">电话明细({this.props.index+1})</div>
                    {this.props.index != 0 ?  <div>
                        <Icon type="minus-circle" alt="" style={{height:20,width:20,marginRight:20,color: '#ff0a0a'}} onClick={this.deleteItem.bind(this,this.props.index)}/>
                    </div> : ''}
                </div>
                {/*<div className="item_sty">
                    <div className="left_title">姓名</div>
                    <input ref='itemname' className="text-right right_input" type="text" placeholder="请输入" maxLength={6} value={this.props.itemata.parentsName} />
                </div>*/}
                <div className="item_sty">
                    <div className="left_title">家长号码</div>
                    <input ref='itemphone' className="text-right right_input" type="number" placeholder="请输入"  maxLength={20} value={this.props.itemata.phone} />
                </div>
                <div className="comhline_sty1"></div>
                <div className="item_sty">
                    <div className="left_title">关系</div>
                    <input ref='itemrelation' className="text-right right_input" type="text" placeholder="请输入" maxLength={6} value={this.props.itemata.relation} />
                </div>
                <div className="comhline_sty1"></div>
            </div>
        )
    }
    deleteItem =(index)=> {
        console.log('index',index)
        this.props.removeSItem(this.props.index)
    }
    handelValueCom = (event)=>{

        //请输入选项内容
        let itemphone = this.refs.itemphone.value;
        let itemrelation = this.refs.itemrelation.value;
        console.log('itemphone',itemphone)
        console.log('itemrelation',itemrelation)
        if(itemphone.length > 0){
            if(itemphone.length <= 11){
                this.props.handelRItem({
                    phone:itemphone,
                    relation:itemrelation
                },this.props.index)
            }else {
                Toast.show('请输入准确电话',1)
                this.props.handelRItem({
                    phone:itemphone,
                    relation:''
                },this.props.index)
                return
            }
        }
    }
}